export default __webpack_public_path__ + "static/about-us-colleen-7d1bec0b78ed27806b3a566212231399.webp";